import {URL_BASE_API } from '../../../configs/urlConfigs';

import service from '../../api';

export const sectorList = (request) => {
    let ENDPOINT = '';
    if(request.data!==undefined){      
      let column = request.data.column;     
      if(column){
        ENDPOINT = URL_BASE_API+'super-admin/sector/?column='+column;
      }
    }else{
        ENDPOINT = URL_BASE_API+'super-admin/sector/';
    }   

    return service.get(ENDPOINT);
    
};

export const sectorAllList = (request) => {
  const ENDPOINT = URL_BASE_API+'super-admin/sectorlist/';

  return service.get(ENDPOINT);
  
};


export const sectorAdd = (request) => {
  const ENDPOINT = URL_BASE_API+'super-admin/sector/';

  return service.post(ENDPOINT,request.data);
  
};

export const sectorEdit = (request) => {
  let sectorId = request.data;
  const ENDPOINT = URL_BASE_API+'super-admin/sector/'+sectorId;

  return service.get(ENDPOINT);  
  
};


export const sectorUpdate = (request) => {
  let sectorId = request.data.id;
  const ENDPOINT = URL_BASE_API+'super-admin/sector/'+sectorId;

  return service.put(ENDPOINT,request.data);  
  
};

export const sectorDelete = (request) => {
  const ENDPOINT = URL_BASE_API+'super-admin/sector/'+request.data;
  return service.delete(ENDPOINT);   
};  